import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchProductGroupList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/products", baseUrl);

  if (params.categoryId) {
    endpointUrl.searchParams.append("categoryId", params.categoryId);
  }

  if (params.category) {
    endpointUrl.searchParams.append("category", params.category);
  }

  if (params.name) {
    endpointUrl.searchParams.append("name", params.name);
  }

  if (params.productNo) {
    endpointUrl.searchParams.append("productNo", params.productNo);
  }

  if (params.productGroupName) {
    endpointUrl.searchParams.append("productGroupName", params.productGroupName);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.saleStatus) {
    endpointUrl.searchParams.append("saleStatus", params.saleStatus);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useProductGroupList(params = {}) {
  return usePaginationQuery(
    [
      "product-groups",
      params.keyword,
      params.categoryId,
      params.category,
      params.productGroupName,
      params.name,
      params.productNo,
      params.from,
      params.to,
      params.saleStatus,
    ],
    (paginationState) =>
      fetchProductGroupList({ ...params, ...paginationState })
  );
}
async function addProductGroup(formData) {
  const res = await http(`/admin/product-groups`, {
    data: formData,
  });
  return res;
}

export function useAddProductGroup() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(addProductGroup, {
    onSuccess: async (res) => {
      if (res?.status === 201 || res?.status === 200) {
        await queryClient.invalidateQueries(["product-groups"]);
        setTimeout(() => {
          navigate("/product-management/product-group");
        }, 1500);
      }
    },
  });
}

export function useUpdateProductGroup() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/product-groups/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res !== undefined) {
          await queryClient.invalidateQueries(["product-groups"]);
          setTimeout(() => {
            navigate("/product-management/product-group/");
          }, 1500);
        }
      },
      onError: () => {
        console.error("Something when wrong");
      },
    }
  );
}

async function deleteProductGroup(id) {
  const data = await http(`/admin/product-groups/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteProductGroup() {
  const navigate = useNavigate();

  return useMutation(deleteProductGroup, {
    onSuccess: () => {
      setTimeout(() => {
        navigate("/product-management/product-group");
      }, 1500);
    },
  });
}

export async function fetchProductGroupDownload() {
  const { data } = await http(`/admin/products-download`, {
    responseType: "blob",
  });

  return data;
}

export function useProductGroupDownload() {
  const { data, ...raResult } = useQuery(["products-download"], () =>
    fetchProductGroupDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
